import googleCertificateEpicClient from 'bundles/epic/clients/GoogleCertificate';

// Mirror of `S12nFreeTrialConfig` defaults on the backend. Epic returns
// integers in this inclusive range — values outside it are treated as an
// invalid override and ignored (defensive parity with EAC's range check).
const MIN_TRIAL_DAYS = 0;
const MAX_TRIAL_DAYS = 10;

const isValidTrialLength = (value: number) =>
  Number.isInteger(value) && value >= MIN_TRIAL_DAYS && value <= MAX_TRIAL_DAYS;

export const generateImpressionForShortS12nFreeTrialOverride = (s12nId?: string): void => {
  const tags = s12nId ? { specialization_id: s12nId } : undefined;
  googleCertificateEpicClient.get('shortS12nFreeTrialOverrideEnabled', tags);
};

/**
 * Read the Short S12N free-trial override from Epic for a given S12n id.
 *
 * @param s12nId - Specialization id (productItemId for an S12N subscription cart).
 * @returns The effective trial days (0–10) when the user is bucketed for this S12n.
 */
export const getShortS12nFreeTrialOverrideDays = (s12nId?: string): number | undefined => {
  const tags = s12nId ? { specialization_id: s12nId } : undefined;

  const isEnabled = googleCertificateEpicClient.preview('shortS12nFreeTrialOverrideEnabled', tags);
  if (!isEnabled) {
    return undefined;
  }

  const override = googleCertificateEpicClient.preview('shortS12nFreeTrialOverrideDayCount', tags);

  if (typeof override !== 'number' || !isValidTrialLength(override)) {
    return undefined;
  }

  return override;
};
